import { Box } from '@mui/material';
import styled from 'styled-components';

export const FeatureSectionContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  flex-direction: ${(props) => (props.isReverse ? 'row-reverse' : 'row')};
  padding: 40px 0;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ImageWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 20px;
  width: 50%;
  position: relative;

  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 40px;
  }
`;
